import { Axios } from './Axios';

export async function getAllAssignmentSubmission(testId, limit = 10, offset = 1) {
  const url = `assignments/submissions?assignmentID=${testId}&limit=${limit}&page=${offset}&sortBy=createdAt:desc&populate=studentID`;
  return Axios({
    url,
    method: 'get'
  });
}

export async function submitAssignment(classId, assignmentObj) {
  const url = `classes/${classId}/assignments/submissions`;
  return Axios({
    url,
    method: 'post',
    data: assignmentObj
  });
}
